<div class="row mb-5">
  <div class="col-12">
    <collapsible-pane
      title="{{ 'roles.statuses' | translate }}"
      (headerAction)="openAdd()"
      [showHeaderBtn]="true"
      [showHeaderBtnText]="'Add'"
      [hideContent]="hideContent" 
      (openedOrClosed)="openStatus($event)"
      class="role-accordion">
      <div class="panel-body w-100">
        <ng-content *ngIf="hideContent"></ng-content>
      </div>
    </collapsible-pane>
  </div>
</div>
